import permissions, { RESOURCE_ACTIVO_FIJO_PG } from '@/auth/permissions/modules/activoFijoPg'
import {
    ROUTE_CONFIGURAR_ITEM_ACTIVO_FIJO,
    ROUTE_CONFIGURAR_TIPO_ACTIVO_FIJO,
    ROUTE_GESTION_PLANTILLA_ACTIVO_FIJO,
} from '@/router/routes/activo-fijo-pg/names'
import { defineMenu } from '@/utils/menu'

const { mantenimiento } = permissions

export default defineMenu([
    {
        title: 'activo_fijo_pg.subopciones.tipos_activos_fijos',
        resource: RESOURCE_ACTIVO_FIJO_PG,
        action: mantenimiento.tipoActivoFijo,
        route: ROUTE_CONFIGURAR_TIPO_ACTIVO_FIJO,
    },
    {
        title: 'activo_fijo_pg.subopciones.gestion_plantilla_activo_fijo',
        resource: RESOURCE_ACTIVO_FIJO_PG,
        action: mantenimiento.gestionPlantillaActivoFijo,
        route: ROUTE_GESTION_PLANTILLA_ACTIVO_FIJO,
    },
    {
        title: 'activo_fijo_pg.subopciones.item_activo_fijo',
        resource: RESOURCE_ACTIVO_FIJO_PG,
        action: mantenimiento.itemActivoFijo,
        route: ROUTE_CONFIGURAR_ITEM_ACTIVO_FIJO,
    },
])
